<template>
    <v-container
      fluid>
        <v-row
            align="center"
            justify="center"
        >
            <v-col
                cols="12"
                sm="6"
                md="3"
                lg="3"
                v-for="item in widgets"
                :key="item.title"
                class="mt-md-0 pl-md-0 pt-0 pt-md-3"
            >
                <v-card
                    class="mx-auto"
                >
                    <v-list-item two-line>
                        <v-list-item-content class="pb-0">
                            <v-list-item-title class="text-h5">
                            {{ item.title }} <v-icon class="mr-1" color="green" v-if="item.icon == 'mdi-arrow-up-bold'">
                                    {{ item.icon }}
                                </v-icon>
                                <v-icon class="mr-1" color="red" v-else-if="item.icon == 'mdi-arrow-down-bold'">
                                    {{ item.icon }}
                                </v-icon>
                                <span class="subheading mr-2">{{ item.percentage }}%</span>
                            </v-list-item-title>
                            <v-list-item-subtitle>{{ item.subtitle }}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>

                    <v-card-text>
                        <v-row align="center">
                            <v-col
                            class="text-h2 pt-0 pb-0 count-up"
                            cols="12"
                            >
                                <ICountUp
                                :delay="delay"
                                :endVal="item.total"
                                :options="options"
                                />
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-list class="transparent">
                        <v-list-item class="sub-widget" 
                            v-for="sitem in item.subwidgets"
                            :key="sitem.title"
                        >
                            <v-list-item-title>{{ sitem.title }}</v-list-item-title>

                            <v-list-item-subtitle class="text-right">
                            {{ sitem.total }}
                            </v-list-item-subtitle>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-col>
        </v-row>
        <v-row
            align="center"
            justify="center"
            class="mt-md-0"
        >
            <Leads />
            <Jobs />
            <Wo />
        </v-row>
        <v-row
            align="center"
            justify="center"
            class="mt-md-0"
        >
            <Lbshape />
            <Lbsize />
            <Lbuser />
        </v-row>
    </v-container>
</template>

<script>
    import axios from 'axios'
    import authmixin from '../mixin/auth.js'
    import Leads from '../components/Charts/Leads.vue'
    import Jobs from '../components/Charts/Jobs.vue'
    import Wo from '../components/Charts/Wo.vue'
    import Lbshape from '../components/Charts/LeadsByShape.vue'
    import Lbsize from '../components/Charts/LeadsBySize.vue'
    import Lbuser from '../components/Charts/LeadsByUser.vue'
    import ICountUp from 'vue-countup-v2'

    export default {
        mixins: [authmixin],
        data: () => ({
            widgets: [],
            delay: 1000,
            options: {
                useEasing: true,
                useGrouping: true,
                separator: ',',
                decimal: '.',
                prefix: '',
                suffix: ''
            },
        }),
        components: { Leads, Jobs, Wo, Lbshape, Lbsize, Lbuser, ICountUp },
        computed: {
        },
        created() {
            this.$store.commit('data/SET_CUSTOMERS', [])
            this.$store.commit('data/SET_JOBS', [])
            this.$store.commit('data/SET_WORKORDERS', [])
        },
        mounted () {
            if (!this.access.includes(this.user.id)) {
                this.$router.push({ path: '/dashboard' })
            }
            this.getWidgets()
        },
        methods: {
            async getWidgets() {
                this.loaded = false

                try {
                    await axios.get('crm/widgets')
                    .then(response => {
                        this.loaded = true
                        this.widgets = response.data
                        this.$nextTick()
                    })
                } catch (e) {
                    console.error(e)
                }
            },
        }
    }
</script>
<style lang="sass">
.v-content
    background: #003a6f

.dashboard-links
    padding: 4px
    
    .col-6
        padding: 4px

        .v-card 
            min-height: calc((100vh - 96px)/3)
            display: flex
            flex-wrap: wrap
            align-content: center
            justify-content: center

.v-application 
    .headline
        font-family: 'Pyxel'!important
        font-size: 1.5em!important

.sub-widget
    min-height: 30px!important

.count-up
    font-weight: 500!important
    color: #001528!important

.mdi-arrow-down-bold + span
    color: #f44336!important

.mdi-up-down-bold + span
    color: #4caf50!important
</style>